import { Component, Input, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ClientNetSavingsTrendBySources } from 'app/core/models/client-net-savings-trend-by-sources.model';
import { MatIcon } from '@angular/material/icon';
import { ClientNetSavingsTrendBySourceGraphComponent } from '../client-net-savings-trend-by-source-graph/client-net-savings-trend-by-source-graph.component';


@Component({
    selector: 'app-client-net-savings-trend-by-source-graph-modal',
    templateUrl: './client-net-savings-trend-by-source-graph-modal.component.html',
    styleUrls: ['./client-net-savings-trend-by-source-graph-modal.component.scss'],
    imports: [MatIcon, ClientNetSavingsTrendBySourceGraphComponent]
})
export class ClientNetSavingsTrendBySourceGraphModalComponent  {
  private activeModal = inject(NgbActiveModal);

  @Input() clientNetSavingsTrendBySources: ClientNetSavingsTrendBySources;

  closeModal($event) {
    $event.preventDefault();
    this.activeModal.close();
  }
}
